import React, {CSSProperties, PointerEventHandler, ReactElement} from "react";
import {Localisation} from "@components/localisation/localisation";
import {LETTER_THEME, LETTER_SIZE, TILE_SIZE} from "@components/core/theme";

const styles: Record<string, CSSProperties> = {
    slot: {
        backgroundColor: "rgba(0, 0, 0, 0.25)",
        borderRadius: 4,
        margin: 4,
        height: LETTER_THEME.container.height,
        width: LETTER_THEME.container.width,
        flexShrink: 0
    },
    content: {
        alignItems: "center",
        backgroundColor: "white",
        borderRadius: 8,
        borderBottom: "rgba(0,0,0,0.35) solid 3px",
        borderRight: "rgba(0,0,0,0.35) solid 3px",
        borderTop: "rgba(255,255,255,0.9) solid 1px",
        borderLeft: "rgba(255,255,255,0.9) solid 1px",
        boxSizing: "border-box",
        display: "flex",
        justifyContent: "center",
        height: LETTER_SIZE.y,
        width: LETTER_SIZE.x,
        overflow: "hidden",
        opacity: 0.35
    },
    enabled: {
        opacity: 1.0
    },
    text: {
        color: "#3d2b1f",
        fontFamily: "Georgia, 'Palatino Linotype', serif",
        fontWeight: "bold",
        userSelect: "none"
    }
};

interface IButton {
    children?: ReactElement
    enabled?: boolean
    onClick: () => void
    text?: string
}

export function TileButton({children, enabled = true, onClick, text}: IButton) {
    const localisedText = Localisation.GetText(text || "");
    const handlePointerDown: PointerEventHandler = (event) => {
        event.stopPropagation();
        enabled && onClick();
    }
    const contentStyle = {...styles.content, ...enabled ? styles.enabled : {}};
    const fontSize = Math.min(TILE_SIZE.x * 0.4, TILE_SIZE.x * 1.4 / localisedText.length);

    return (
        <div style={styles.slot}>
            <div onPointerDown={handlePointerDown} style={contentStyle}>
                {text && <span style={{...styles.text, fontSize}}>{localisedText}</span>}
                {children || null}
            </div>
        </div>
    );
}